import React, { Component, Fragment } from "react";
import { Button, Form, Spin, Tabs } from "antd";
import PropTypes from "prop-types";
import { withApollo } from "react-apollo";
import { Link } from "react-router-dom";
import _ from "lodash";

import Container from "../../../../../components/user/Container";
import SecAttachment from "../sector/SecAttachment";
import SecWelfareReimbursementInformation from "../sector/SecWelfareReimbursementInformation";
import SecDisasterHistory from "../sector/SecDisasterHistory";
import { checkLinkUrlVtrcCustom } from "../../../../../utils/auth";
import { getUrlImage } from "../../../../../utils/fetchImage";
import axiosAPI from "../../../../../config/axiosAPI";

class WelfareListOtherWelfare extends Component {
  state = {
    loadingFullpage: true,
    otherWelfareData: {},
  };

  componentDidMount() {
    this.getOtherWelfareDetailById();
  }

  async getOtherWelfareDetailById() {
    const { match } = this.props;
    const id = match.url.split("/")[5];

    try {
      const response = await axiosAPI.get(
        `https://vtrcapi.redcross.or.th/benefit-api/api/v1/payments/getOtherWelfareDetailById?id=${id}`
      );

      if (response?.data && !_.isEmpty(response?.data)) {
        const otherWelfareData = response.data;
        const welfareAttachment =
          otherWelfareData?.welfareAttachment &&
          !_.isEmpty(otherWelfareData?.welfareAttachment)
            ? otherWelfareData.welfareAttachment
            : [];

        if (welfareAttachment.length) {
          const url = checkLinkUrlVtrcCustom();
          let objFile = "";
          let file = {};
          for (let i = 0; i < welfareAttachment.length; i++) {
            objFile = await getUrlImage(
              `${url}/file`,
              welfareAttachment[i].attachmentRefId
            );
            file = {
              base64: objFile?.base64 || "",
              filetype: objFile?.filetype || "",
              filename: "",
              fileIdBase64: objFile?.base64 || "",
              fileBase64: objFile?.base64 || "",
              fileMimeType: objFile?.filetype || "",
            };
            welfareAttachment[i] = { ...welfareAttachment[i], file };
          }
          otherWelfareData.welfareAttachment = welfareAttachment;
        }

        const welfareBankDetail =
        otherWelfareData?.welfareBankDetail &&
        !_.isEmpty(otherWelfareData?.welfareBankDetail)
          ? otherWelfareData.welfareBankDetail
          : [];

      if (welfareBankDetail.length) {
        const url = checkLinkUrlVtrcCustom();
        let objFile = "";
        let file = {};
        for (let i = 0; i < welfareBankDetail.length; i++) {
          objFile = await getUrlImage(
            `${url}/file`,
            welfareBankDetail[i].attachmentRefId
          );
          file = {
            base64: objFile?.base64 || "",
            filetype: objFile?.filetype || "",
            filename: "",
            fileIdBase64: objFile?.base64 || "",
            fileBase64: objFile?.base64 || "",
            fileMimeType: objFile?.filetype || "",
          };
          welfareBankDetail[i] = { ...welfareBankDetail[i], file };
        }
        otherWelfareData.welfareBankDetail = welfareBankDetail;
      }


        this.setState({
          otherWelfareData,
          loadingFullpage: false,
        });
      }
    } catch (error) {
      console.error(`Error: ${error}`);
    }
  }

  render() {
    const { match } = this.props;
    const { loadingFullpage, otherWelfareData } = this.state;

    return (
      <Container match={match}>
        <div className="breadcrumb-custom pb-3 mb-4">
          <span style={{ fontSize: "18px" }}>เบิกสวัสดิการอื่นๆ</span>
        </div>
        <Spin spinning={loadingFullpage} delay={0}>
          <Form ref={this.formRef}>
            <div className="card-container" id="page-profile">
              <div className="px-5 py-1 card-bg-green">
                {!_.isEmpty(otherWelfareData) ? (
                  <Tabs type="card" className="my-4" defaultActiveKey="1">
                    <Tabs.TabPane
                      tab={"ข้อมูลการเบิกสวัสดิการ"}
                      key="1"
                      className="mb-0"
                    >
                      <SecWelfareReimbursementInformation
                        forceRender
                        rawData={otherWelfareData}
                      />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={"เอกสารแนบ"} key="2" className="mb-0">
                      <SecAttachment forceRender rawData={otherWelfareData} />
                    </Tabs.TabPane>
                    <Tabs.TabPane
                      tab={"ประวัติการดำเนินการ"}
                      key="3"
                      className="mb-0"
                    >
                      <SecDisasterHistory
                        forceRender
                        rawData={otherWelfareData}
                      />
                    </Tabs.TabPane>
                  </Tabs>
                ) : (
                  <Fragment />
                )}
                <div className="mb-4" align="center">
                  <Link to="/welfare/welfareList">
                    <Button type="primary" className="mx-2 btn-white-red">
                      ย้อนกลับ
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </Form>
        </Spin>
      </Container>
    );
  }
}

WelfareListOtherWelfare.defaultProps = {
  autoFocus: false,
};

WelfareListOtherWelfare.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListOtherWelfare = Form.create()(WelfareListOtherWelfare);

export default withApollo(WrappedWelfareListOtherWelfare);
